import { CSSObject } from '@mui/material/styles';

export const grow = (
	{
		scale,
		positionX,
		positionY,
	}: { scale: number; positionX: string; positionY: string },
	style?: CSSObject,
): CSSObject => ({
	transformOrigin: `${positionX} ${positionY}`,
	'&:hover': {
		transform: `scale(${scale})`,
		...style,
	},
});
